/* eslint-disable */
import React, {Component, useState} from 'react';
import {Container, DropContainer, UploadMessage, StyledTbody} from './styles';
import Carrinho from '../../../assets/emojis/carrinho/carrinho@3x.png';
import {IoMdClose} from 'react-icons/io';
import Dropzone from 'react-dropzone';
import CurrencyInput from 'react-currency-input';
import {FiChevronDown} from 'react-icons/fi';
import {FaCheck} from 'react-icons/fa';
import {IoArrowBack} from 'react-icons/io5';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';
import Individual from '../../../assets/produtos/tamanho/1/profile@3x.png';
import Dois from '../../../assets/produtos/tamanho/2/2-users@3x.png';
import Tres from '../../../assets/produtos/tamanho/3/3-users@3x.png';
import Quatro from '../../../assets/produtos/tamanho/4/4-users@3x.png';
import Nao from '../../../assets/produtos/tamanho/0/menos@3x.png';
import Smiley from '../../../assets/emojis/smiley/coracao-olhos@3x.png';
import ImageIcon from '../../../assets/icon_image.svg';
import Lixeira from '../../../assets/produtos/lixeira/icon/fechar-circle@3x.png'
import {CircularProgressbar} from 'react-circular-progressbar';
import { uniqueId } from 'lodash';
import filesize from 'filesize';
import { MdCheckCircle, MdError } from 'react-icons/md';
import {HiOutlinePlus} from 'react-icons/hi';
import api from '../../../services/api';
import Modal from 'react-modal';
import ModalSelect from './modalSelect';
import ModalAdicional from './modalAdicional';
import ModalApagar from './modalApagar';
import {Switch} from 'antd';
import { Spinner } from 'react-activity';
import { PresetColorTypes } from 'antd/lib/_util/colors';
import {CgTrash} from 'react-icons/cg';
import {FiGrid, FiList, FiTrash2} from 'react-icons/fi';
import {MdReorder, MdMoreVert} from 'react-icons/md';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {Menu, MenuItem, Fade} from '@material-ui/core';

import prodNoImg from "../../../assets/produtos/produto_sem-imagem.svg"

export default class ModalProduto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            superUser: false,
            categorias: props.categorias,
            preco: 0.00,
            imagem: null,
            ingredientes: '',
            activeTab: 1,
            nome: '',
            categoriaId: props.categoria_id,
            categoria: props.categoria,
            tamanho: 0,
            categoriaClass: 'div-input',
            precoClass: 'div-input',
            ingredientesClass: 'div-input-box',
            nomeClass: 'div-input',
            progress1: 0 + ((2/6) * 100),
            progress2: 100,
            progress3: 0,
            uploaded: [],
            options: 6,
            filled: [],
            token: props.token,
            windowWidth: window.innerWidth,
            isOpen: false,
            adicionais: 0,
            modalAdicional: false,
            grupos: [],
            retorno: {
                // id: null,
                // imagem: 'e09a3c1d45ed6c978a4156e79b5768b2',
                // nome: 'Refrigerante Coca-cola',
                // categoria: 'Refrigerante',
                // ingredientes: 'Refrigerante bem gelado.',
                // preco: 10.9,
                // grupos_adicionals: [
                //     {
                //         descricao: 'Sabores',
                //         quantidade: 8
                //     },
                //     {
                //         descricao: 'Tamanho',
                //         quantidade: 4
                //     }
                // ]
            },
            situacao: false,
            modalPraApagar: '',
            modalApagarId: null,
            modalApagar: false,
            showSizeError: false,
            edicaoGrupo: {},
            produto_id: null,
            grupo_id: null,
            list: false,
            valorMinimo: null, //ref. 'a partir de' do produto
            inputPreco: false, 
        }
    }

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    }

    async changeTab(type) {
        const active = this.state.activeTab;
        if (type === 'next' && active !== 2) {
            
            if (!!this.state.nome.length && !!this.state.categoria.length && this.state.tamanho !== 0) {
                if (active < 3 && this.state.progress1 >= 83) {
                    this.setState({
                        activeTab: active + 1
                    })
                }
            } else {
                if (!this.state.nome.length || !this.state.categoria.length || this.state.tamanho === 0) {
                    this.props.customError("Ocorreu um erro. Todos os campos são de preenchimento obrigatório.");
                }
                if (!this.state.nome.length) {
                    this.setState({nomeClass: 'div-input-error'});
                }
                if (!this.state.categoria.length) {
                    this.setState({categoriaClass: 'div-input-error'});
                }
                // if (!this.state.ingredientes.length) {
                //     this.setState({ingredientesClass: 'div-input-error-box'});
                // }
                if (this.state.tamanho === 0) {
                    this.setState({showSizeError: true});
                }
            }
        }

        if (type === 'next' && active === 2) {
            if (active < 3 && this.state.progress2 >= 99) {
                if (this.props.edicao) {
                    await this.updateProduto();
                } else {
                    await this.postProduto().then(() => {
                        this.setState({
                            activeTab: active + 1
                        });
                    })
                }
            }
        }

        if (type === 'back') {
            if (active > 1) {
                this.setState({
                    activeTab: active - 1
                })
            }
        }
        this.props.refresh();
    }

    async atualizarGrupoEproduto() {
        try {
            api.put('api/produtos/atualizar', {
                produto_id: this.state.produto_id,
                nome: this.state.nome,
                imagem: this.state.imagem,
                descricao: this.state.ingredientes,
                valor: this.state.preco,
                quantidade_pessoas: this.state.tamanho,
                ativo: this.state.ativo,
                grupos_adicionais: this.state.grupos,
                categoria_id: this.state.categoriaId
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                this.props.success()
            }).catch(e => {
                this.props.error()
            });
        } catch (e) {
            console.log(e.data)
        }
    }

    async updateProduto() {
        try {
            api.put('api/produtos/atualizar', {
                produto_id: this.state.produto_id,
                nome: this.state.nome,
                imagem: this.state.imagem,
                descricao: this.state.ingredientes,
                valor: this.state.preco,
                quantidade_pessoas: this.state.tamanho,
                ativo: this.state.ativo,
                grupos_adicionais: this.state.grupos,
                categoria_id: this.state.categoriaId

            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                this.props.success();
            }).catch(e => {
                this.props.error();
            });
        } catch (e) {
            console.log(e.data);
        }
        // if (typeof this.state.uploaded[0].error !== 'undefined') {
            if (typeof this.state.uploaded[0] !== 'undefined') {
            this.processUpload(this.state.uploaded[0], this.state.produto_id)
        }
        this.props.refresh();
        await this.props.refresh();
        this.props.closeModal();
    }

    handleInputs(event) {
        switch (event.target.name) {
            case 'preco':
                var preco = event.target.value;
                var formatValue1 = preco.split(' ');
                var formated1 = formatValue1[1]?.replace(/,/g, '.');
                this.setState({
                    preco: Number(formated1).toFixed(2)
                });
                break;
            case 'ingredientes':
                this.setState({
                    ingredientes: event.target.value
                });
                if (!!event.target.value.length) {
                    this.counter('add', 'ingredientes')
                } else {
                    this.counter('del', 'ingredientes')
                }
                break;
            case 'nome':
                this.setState({
                    nome: event.target.value
                });
                if (!!event.target.value.length) {
                    this.counter('add', 'nome')
                } else {
                    this.counter('del', 'nome')
                }
                break;
            default:
                break;
        }
    }

    async componentDidMount() {
        Modal.setAppElement('body');
        let componentDidMount_super = CurrencyInput.prototype.componentDidMount;
        CurrencyInput.prototype.componentDidMount = function() {
            if(!this.props.autoFocus) {
                let setSelectionRange_super = this.theInput.setSelectionRange;
                this.theInput.setSelectionRange = () => {};
                componentDidMount_super.call(this, ...arguments);
                this.theInput.setSelectionRange = setSelectionRange_super;
            }
            else {
                componentDidMount_super.call(this, ...arguments);
            }
        };
        let componentDidUpdate_super = CurrencyInput.prototype.componentDidUpdate;
        CurrencyInput.prototype.componentDidUpdate = function() {
            if(!this.props.autoFocus) {
                let setSelectionRange_super = this.theInput.setSelectionRange;
                this.theInput.setSelectionRange = () => {};
                componentDidUpdate_super.call(this, ...arguments);
                this.theInput.setSelectionRange = setSelectionRange_super;
            }
            else {
                componentDidMount_super.call(this, ...arguments);
            }
        };
        window.addEventListener("resize", this.handleResize);
        if (this.props.edicao) {
            await this.getProduto();
            // this.counter('add', 'foto');
            this.counter('add', 'nome');
            this.counter('add', 'categoria');
            this.counter('add', 'tamanho');
            this.counter('add', 'ingredientes');
            this.setState({
                progress2: 100
            });
        }
        if (this.props.categoria_id !== null) {
            this.counter('add', 'categoria')
        }
    }

    async componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize, false)
    }

    async putAtivo() {
        await api.put('api/produtos/atualizar', {
            produto_id: this.state.retorno.id,
            ativo: this.state.situacao
        }, {
            headers: {
                Authorization: `Bearer ${this.state.token}`
            }
        }).then(res => {}).catch(async e => {})
    }

    async getProduto() {
        await api.get(`api/produtos/produto_unico/${this.props.produto}`, {
            headers: {
                Authorization: `Bearer ${this.state.token}`
            }
        }).then(res => {
            this.setState({
                uploaded: [{
                    preview: res.data.imagem != null ? `https://appedidos-share-private.s3.amazonaws.com/${res.data.imagem}` : 'https://appedidos-share-private.s3.amazonaws.com/produto-sem-foto-listagem.jpg' ,
                    uploaded: true
                }],
                imagem: res.data.imagem,
                nome: res.data.nome,
                categoriaId: res.data.categoria_produto_id,
                categoria: res.data.categoria_produto.nome,
                tamanho: res.data.quantidade_pessoas,
                ingredientes: res.data.descricao,
                preco: res.data.valor,
                grupos: res.data.grupos_adicionals,
                produto_id: res.data.id,
                ativo: res.data.ativo,
                valorMinimo: res.data.valor_minimo,
            });
            if (!!res.data.grupos_adicionals.length) {
                this.setState({
                    adicionais: 1
                })
            } else {
                this.setState({
                    adicionais: 0
                })
            }
        }).catch(async e => {
            if (e.response.status === 401) {
                try {
                    await localStorage.removeItem('@username');
                            await localStorage.removeItem('@jwt');
                            await localStorage.removeItem('@user');
                            await localStorage.removeItem('@rest');
                            await localStorage.removeItem('@uf');
                            await localStorage.removeItem('@internal');
                            await localStorage.removeItem('@suser');
                    this.setState({
                        redirect: true
                    })
                } catch (e) {
                    console.log(e.data);
                }
            }
        })
        this.props.refresh()
    }

    async postProduto() {
        let {retorno} = this.state;
        try {
            await api.post('api/produtos/criar', {
                nome: this.state.nome,
                imagem: null,
                categoria_id: this.state.categoriaId,
                descricao: this.state.ingredientes,
                valor: this.state.preco,
                ativo: false,
                indisponivel: false,
                quantidade_pessoas: this.state.tamanho,
                grupos_adicionais: this.state.grupos
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                retorno.id = res.data.produto.id;
                retorno.nome = res.data.produto.nome;
                retorno.imagem = res.data.produto.imagem;
                retorno.categoria = this.state.categoria;
                retorno.ingredientes = res.data.produto.descricao;
                retorno.preco = res.data.produto.valor;
                retorno.grupos_adicionals = res.data.create_grupos_adicionais;
                this.setState({
                    retorno
                });
                this.processUpload(this.state.uploaded[0], res.data.produto.id);
                this.props.refresh();
                // this.props.closeModal();
            }).catch(async e => {
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (e) {
           console.log(e); 
        }
    }

    handleUpload = file => {
        const uploaded = file.map(file => ({
            file,
            id: uniqueId(),
            name: file.name,
            readableSize: filesize(file.size),
            preview: URL.createObjectURL(file),
            progress: 0,
            uploaded: false,
            error: false,
            url: null,
        }));

        this.setState({
            uploaded
        });
        // this.counter('add', 'foto');
        // if (this.props.edicao) {
        //     this.processUpload(this.state.uploaded[0], this.state.produto_id);
        // }
    }

    renderDragMessage = (isDragActive, isDragReject, state, type) => {
        if (isDragActive) {
            if (isDragReject) {
                return <UploadMessage type="error">
                    <span className="bold">Arquivo não suportado</span>
                </UploadMessage>
            } else {
                return <UploadMessage >
                    <span className="bold">Solte a imagem aqui</span>
                </UploadMessage>
            }
        }

        if (!!state.length) {
            return <UploadMessage>
                <span className="nome">{state[0].name}</span>
                <span>Para alterar a imagem arraste e solte ou clique 
                <p>para importar do seu dispositivo.</p></span>
            </UploadMessage>
        }

        if (!state.length) {
            return (
                this.state.windowWidth > 423 ? (
                    <UploadMessage>
                        <span><span className="bold">Arraste e solte</span> {type ? 'o seu logo' : 'a foto do seu produto'} 
                        <p>ou <span className="bold">clique para importar</span> do seu dispositivo.</p></span>
                    </UploadMessage>
                ) : (
                    <UploadMessage>
                        <span><span className="bold">Tire a foto</span> {type ? 'o seu logo' : 'do seu produto'} 
                        <p>ou <span className="bold">clique para importar</span> <p>do seu dispositivo.</p></p></span>
                    </UploadMessage>
                )
            )
        }
    }

    counter = (type, component) => {

        let array = this.state.filled;
        const filledComponent = this.state.filled.findIndex(fill => component === fill);
        if (filledComponent === -1) {
            array.push(component);
            if (type === 'add') {
                const calculo = this.state.progress1 + ((1/this.state.options) * 100);
                this.setState({
                    progress1: calculo, 
                    filled: array
                });
            } 
        }
        if (type === 'del') {
            array.splice(filledComponent, 1);
            const calculo = this.state.progress1 - ((1/this.state.options) * 100);
            this.setState({
                progress1: calculo,
                filled: array
            });
        }
    }

    handleTamanho(type) {
        this.setState({
            tamanho: type,
            showSizeError: false
        });
        this.counter('add', 'tamanho');
    }

    handleDelFoto() {
        if (this.props.edicao) {
            try {
                api.post('api/delete_image_s3', {
                    file_name: this.state.imagem
                }, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    console.log(res.data);
                })
            } catch (e) {
                console.log(e.data);
            }
        }
        this.setState({ uploaded: [], imagem: null });
        this.props.refresh();
        // this.counter('del', 'foto');
    }

    controllerModal(estado){
        if (this.state.categoriaClass === 'div-input') {
            this.setState({
                categoriaClass: 'div-input-focado'
            })
        } else {
            this.setState({
                categoriaClass: 'div-input'
            })
        }
        this.setState({
            isOpen: !estado,
        });
      }

      controllerModalAdicional(estado){
        this.setState({
            modalAdicional: !estado,
        });
      }

      controllerModalApagar(estado){
        this.setState({
            modalApagar: !estado,
        });
      }
    
      setCategoria(id, nome) {
        this.setState({
            categoriaId: id,
            categoria: nome
        });
        this.controllerModal(this.state.isOpen); 
        this.counter('add', 'categoria');
    }

    toggleAdicionais(tipo) {
        this.setState({ adicionais: tipo, progress2: 100 });
    }

    //cria e adiciona os adicionais ao criar o produto
    gruposPush(id, ativo, nome, obrigatorio, min, max, cobranca, adicionais, editavel, qtdExata) {
        let {grupos} = this.state;
        if (JSON.stringify(this.state.edicaoGrupo) !== '{}') {
            for (let i = 0; i < grupos.length; i++) {
                if (grupos[i].id === id) {
                    grupos.splice(i, 1, {
                        id,
                        maximo: max,
                        minimo: min,
                        obrigatorio: obrigatorio,
                        tipo_cobranca: cobranca,
                        descricao: nome,
                        ativo,
                        adicionals: adicionais,
                        editavel: editavel,
                        qtd_exata: qtdExata
                    });
                }
            }
        } else {
            grupos.push(
                {
                    id,
                    maximo: max,
                    minimo: min,
                    obrigatorio: obrigatorio,
                    tipo_cobranca: cobranca,
                    descricao: nome,
                    ativo,
                    adicionals: adicionais,
                    editavel: editavel,
                    qtd_exata: qtdExata
                }
            );
        }
        this.setState({grupos});
        if (this.props.edicao) {
            const data = [{
                maximo: max,
                minimo: min,
                ativo,
                obrigatorio,
                tipo_cobranca: cobranca,
                descricao: nome,
                produto_id: this.state.produto_id,
                grupo_adicional_id: id,
                qtd_exata: qtdExata
            }];
            try {
                api.put('api/grupo_adicional/atualizar', data, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    console.log(res.data);
                });
            } catch (e) {
                console.log(e.data);
            }
        }
        this.controllerModalAdicional(this.state.modalAdicional);
    }

    updateItem = (id, data) => {
        this.setState({ grupos: this.state.grupos.map(item => {
            return id === item.id 
                ? { ...item, ...data }
                : item;
            })
        });
    };

    editarGrupo(item) {
        this.setState({edicaoGrupo: item, grupo_id: item.id});
        this.controllerModalAdicional(this.state.modalAdicional);
    }

    limparPrevGrupo() {
        this.setState({edicaoGrupo: {}});
    }

    //cria e adiciona os adicionais ao editar o produto
    criarGrupo(id, ativo, nome, obrigatorio, min, max, cobranca, adicionais, editavel, qtdExata) {
        //atualiza os id's que foram gerados pelo uniqId() para null,
        //ao editar produto, id precisa ser null para ser criado o item adicional
        const adicionaisArray = adicionais.map(itens => {
            if (typeof itens.id == "string") {
                return { ...itens, id: null };
            } else {
            return itens;
            }
        });
        this.setState({edicaoGrupo: {}});

        const data = [{
            grupo_id: id,
            produto_id: this.state.produto_id,
            ativo: ativo,
            descricao: nome,
            obrigatorio: obrigatorio,
            minimo: min,
            maximo: max,
            tipo_cobranca: cobranca,
            adicionais: adicionaisArray,
            editavel: editavel,
            qtd_exata: qtdExata
        }];
        if (!editavel) {
            try {

                api.post('api/grupo_adicional/criar', data,  {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    // após criar o grupo adicional atualiza o produto
                    this.atualizarGrupoEproduto()

                    let arrayDeGrupos = [...this.state.grupos]
                    arrayDeGrupos.push(res.data.produto)
                    this.setState({grupos: arrayDeGrupos})
                    this.setState({adicionais: res.data.adicionais})

                    this.setState({grupo_id: res.data.produto.id})
                    this.controllerModalAdicional(this.state.modalAdicional)
                    this.getProduto()
                })

            } catch (e) {
                console.log(e.data);
            }
        } else {
            try {
                api.put('api/grupo_adicional/atualizar', data, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    // após atualizar o grupo adicional atualiza o produto
                    this.atualizarGrupoEproduto()

                    let arrayDeGrupos = [...this.state.grupos]
                    arrayDeGrupos.push(res.data.produto)
                    this.setState({grupos: arrayDeGrupos})
                    this.setState({adicionais: res.data.adicionais})

                    this.setState({grupo_id: res.data.produto.id})
                    this.controllerModalAdicional(this.state.modalAdicional)
                    this.getProduto()
                })
            } catch (e) {
                console.log(e.data)
            }
        }
    }

    handleSituacao() {
        let {situacao} = this.state;
        situacao = !situacao
        this.setState({
            situacao
        });
    }

    confirmApagar(id) {
        this.deleteGroup(id);
        this.controllerModalApagar(this.state.modalApagar);
    }

    deleteGroup(id) {
        let {grupos} = this.state;
        for (let i = 0; i < grupos.length; i++) {
            if (grupos[i].id === id) {
                grupos.splice(i, 1)
            }
        }
        if (this.props.edicao) {
            if (typeof id === 'number') {
                try {
                    api.put('api/grupo_adicional/deletar', {
                        produto_id: this.state.produto_id,
                        grupo_adicional_id: id
                    }, {
                        headers: {
                            Authorization: `Bearer ${this.state.token}`
                        }
                    }).then(res => {
                        this.props.success();
                    }).catch(e => {
                        this.props.error();
                    });
                } catch (e) {
                    console.log(e.data);
                }
            }
        }
        this.setState({grupos});
    }

    openModalApagar(id, nome) {
        this.setState({
            modalPraApagar: nome,
            modalApagarId: id
        });
        this.controllerModalApagar(this.state.modalApagar);
    }

    updateImage = (id, data) => {
        this.setState({ uploaded: this.state.uploaded.map(uploadedFile => {
            return id === uploadedFile.id 
                ? { ...uploadedFile, ...data }
                : uploadedFile;
            })
        });
    };

    processUpload = (upload, id) => {
        if (!upload.uploaded) {
            const data = new FormData();
            let {retorno} = this.state;
            data.append('file', upload.file, upload.name);
            api.patch(`api/image_upload/produto/${id}`, data, {
                onUploadProgress: e => {
                    const progress = parseInt(Math.round(e.loaded * 100 / e.total));
                    this.updateImage(upload.id, {
                        progress,
                    })
                },
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(async res => {
                if (!this.props.edicao) {
                    const url = res.data.key;
                    retorno.imagem = url;
                    this.setState({retorno})
                    this.updateImage(upload.id, {
                        uploaded: true,
                    });
                } else {
                    this.updateImage(upload.id, {
                        uploaded: true,
                    });
                    this.setState({
                        imagem: res.data.key
                    });
                }
                this.props.refresh();
                // this.success();
            }).catch(e => {
                // if (e.response.status === 500) {
                //     alert('Seu arquivo ultrapassou o limite de tamanho. Por favor, escolha outro arquivo e faça o upload.');
                // }
                this.updateImage(upload.id, {
                    error: true,
                });
                // this.error();
            })
        }
    }

    salvarAlteracoes() {
        if (this.state.situacao) {
            this.putAtivo().then(() => {
                this.props.refresh();
                this.props.closeModal();
                this.props.success();
            });
        } else {
            this.props.refresh();
            this.props.closeModal();
        }
    }

    orderGroup(items) {
        const ordered = items.map((item, index) => {
            item.ordem = index + 1;
            return {...item}
        });
        try {
            api.patch('api/grupo_adicional/ordenar', {
                produto_id: this.state.produto_id,
                grupos_adicionais: ordered
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                this.props.success();
            }).catch(e => {
                this.props.error();
            })
        } catch (e) {
            console.log(e);
        }
    }

    handleOnDrag = (result) => {
        if (!result.destination) return;
        const items = Array.from(this.state.grupos);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        this.setState({
            grupos: items
        });
        if (this.props.edicao) {
            this.orderGroup(items);
        }
    }

    async handleAtivo(id, ativo) {
        let array = this.state.grupos;
        if (this.props.edicao) {
            const data = [{
                grupo_adicional_id: id,
                produto_id: this.state.produto_id,
                ativo
            }];
            try {
                await api.put('api/grupo_adicional/atualizar', data, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    for (let i = 0; i < array.length; i++) {
                        if (array[i].id === id) {
                            array[i].ativo = ativo
                        }
                    }
                    this.setState({ 
                        grupos: array
                    });
                    this.props.success();
                })
            } catch (e) {
                this.props.error();
            }
        } else {
            for (let i = 0; i < array.length; i++) {
                if (array[i].id === id) {
                    array[i].ativo = ativo
                }
            }
            this.setState({ 
                grupos: array
            });
        }
    }

    openInputPreco = () =>{
        this.setState({inputPreco: true})
        setTimeout(() => {
            document.getElementById('preco-atual').scrollIntoView({behavior: 'smooth'})
        }, 100)
    }

    RenderList = ({group, index}) => {
        const [menu, showMenu] = useState(null);
        const handleClick = (event) => {
            showMenu(event.currentTarget);
        };
          const handleClose = () => {
            showMenu(null);
        };
        const verMais = () => {
            handleClose();
            this.editarGrupo(group);
        }
        const handleStatus = () => {
            handleClose();
            this.handleAtivo(group.id, !group.ativo);
        }
        const excluirProd = () => {
            handleClose();
            this.openModalApagar(group.id, group.descricao);
        }
        return (
            <>
            <Draggable
                style={(_isDragging, draggableStyle) => ({ ...draggableStyle, position: 'static' })}
                draggableId={String(group.id)}
                index={index}>
                    {(provided, snapshot) => (
                        <StyledTbody
                        isDragging={snapshot.isDragging}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}>
                            <tr>
                                <td className="td-drag" style={{cursor: "grab"}}>
                                    <MdReorder 
                                        className="icon"/>
                                </td>
                                <td className="td-nome">{group.descricao}</td>
                                <td className="td-nome">{group.adicionals.length}</td>
                                <td className="td-switch">
                                    <div>
                                        <label className="switch">
                                        <Switch
                                            onChange={
                                                () => this.state.superUser ? 
                                                this.state.permission === 2 ? this.handleAtivo(group.id, !group.ativo) : null 
                                                : this.handleAtivo(group.id, !group.ativo)
                                            }
                                            defaultChecked={group.ativo}
                                            checked={group.ativo}
                                        />
                                        <h4>{group.ativo ? 'Ativo' : 'Inativo'}</h4>
                                    </label>
                                        <button className="more-button" onClick={handleClick}>
                                            <MdMoreVert className="icon" />  
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </StyledTbody>
                    )}
            </Draggable>
            <StyledMenu
                id="simple-menu"
                anchorEl={menu}
                keepMounted
                open={Boolean(menu)}
                onClose={handleClose}
            >
                <StyledMenuItem onClick={verMais}>Ver mais</StyledMenuItem>
                <StyledMenuItem onClick={handleStatus}>Status {group.ativo ? "inativo" : "ativo"}</StyledMenuItem>
                <StyledMenuItem onClick={excluirProd}>Excluir grupo</StyledMenuItem>
            </StyledMenu>
            </>
        )
    }

    render() {
        return(
            <Container>
                <Modal
                    isOpen={this.state.isOpen}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModal(this.state.isOpen)}
                    closeModal={() => this.controllerModal(this.state.isOpen)}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 930  ? entrada : mobile}
                    contentLabel="Modal"
                    >
                        <ModalSelect
                            categorias={this.state.categorias}
                            selecionar={(id, nome) => this.setCategoria(id, nome)}
                            closeModal={() => this.controllerModal(this.state.isOpen)}/>
                </Modal>
                <Modal
                    isOpen={this.state.modalAdicional}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModalAdicional(this.state.modalAdicional)}
                    shouldCloseOnEsc={false}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={100}
                    style={adicionalStyle}
                    contentLabel="Modal"
                    >
                        <ModalAdicional
                            // salvar={(id, turno, entrada, saida) => this.salvar(id, turno, entrada, saida)}
                            // id={this.state.id}
                            // turno={this.state.qualTurno}

                            //"this.state.grupo_id" foi utilizado p/ forçar o valor do grupo id
                            success={() => this.props.success()}
                            error={() => this.props.error()}
                            grupo_id={this.state.grupo_id}
                            produto_id={this.state.produto_id}
                            edicao={this.props.edicao}
                            prevInfos={this.state.edicaoGrupo}
                            limparPrevGrupo={() => this.limparPrevGrupo()}
                            token={this.state.token}
                            // push={(id, ativo, nome, obrigatorio, min, max, cobranca, adicionais) => this.gruposPush(id, ativo, nome, obrigatorio, min, max, cobranca, adicionais)}
                            push={(id, ativo, nome, obrigatorio, min, max, cobranca, adicionais, editavel, qtdExata) => {
                                this.state.produto_id && this.criarGrupo(id, ativo, nome, obrigatorio, min, max, cobranca, adicionais, editavel, qtdExata)
                                !this.state.produto_id && this.gruposPush(id, ativo, nome, obrigatorio, min, max, cobranca, adicionais, editavel, qtdExata)
                            }} //this.state.grupo_id
                            closeModal={() => this.controllerModalAdicional(this.state.modalAdicional)}
                        />
                </Modal>
                <Modal
                    isOpen={this.state.modalApagar}
                    onRequestClose={() => this.controllerModalApagar(this.state.modalApagar)}
                    shouldCloseOnEsc={false}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={100}
                    style={apagarStyle}
                    contentLabel="Modal"
                    >
                    <ModalApagar 
                        id={this.state.modalApagarId}
                        grupo={this.state.modalPraApagar}
                        confirm={(id) => this.confirmApagar(id)}
                        closeModal={() => this.controllerModalApagar(this.state.modalApagar)}/>
                </Modal>
                <div className="top-bar">
                        <div className="textos">
                            <div className={this.state.activeTab === 1 ? 'section' : this.state.activeTab !== 1 && this.state.progress1 >= 99 ? 'section-filled' : 'section-disabled'}>
                                <div className="bola">
                                    {this.state.activeTab !== 1 && this.state.progress1 >= 99 ? (
                                        <FaCheck size={12} color="#fff" />
                                    ) : (<span>1</span>)}
                                </div>
                                <span className="text">Informações básicas</span>
                            </div>

                            <div className={this.state.activeTab === 2 ? 'section' : this.state.activeTab !== 2 && this.state.progress2 >= 99 ? 'section-filled' : 'section-disabled'}>
                                <div className="bola">
                                {this.state.activeTab !== 2 && this.state.progress2 >= 99 ? (
                                        <FaCheck size={12} color="#fff" />
                                    ) : (<span>2</span>)}
                                </div>
                                <span className="text">Adicionar opções</span>
                            </div>

                            {this.props.edicao !== true && (
                                <div className={this.state.activeTab === 3 ? 'section' : 'section-disabled'}>
                                    <div className="bola">
                                        <span>3</span>
                                    </div>
                                    <span className="text">Ativar produto</span>
                                </div>
                            )}
                        </div>

                        {this.state.windowWidth > 426 && (
                            <div className="close">
                                <button 
                                    onClick={() => this.props.closeModal()}>
                                    <IoMdClose color="#fff" className="i-close" />
                                </button>
                            </div>
                        )}
                </div>
                {this.state.activeTab === 2 ? (
                    <div style={{position: "relative"}}>
                    {this.state.windowWidth <= 426 && (
                            <div className="close">
                                <button 
                                    onClick={() => this.props.closeModal()}>
                                    <IoMdClose color="#fff" className="i-close" />
                                </button>
                            </div>
                        )}
                    <div className="header">
                    <img alt="" className="emoji" src={Carrinho} />
                    <h1>{this.props.edicao ? 'Editar produto' : 'Adicionar novo produto'}</h1>
                    <h5>Legal! Agora que você já preencheu as informações 
básicas, vamos para as opções.</h5>
                </div>

                <div className="adicionais">
                    <h4>Adicionais</h4>
                    <h5>Seu produto possui itens adicionais?</h5>

                    <div className="options">
                        <div onClick={
                            () => this.state.superUser ? 
                            this.state.permission === 2 ? this.toggleAdicionais(0) : null 
                            : this.toggleAdicionais(0)
                        }
                            name="nao"
                            className={this.state.adicionais === 0 ? 'option-selected' : 'option'}>
                            <span>Não</span>
                        </div>
                        <div onClick={
                            () => this.state.superUser ? 
                            this.state.permission === 2 ? this.toggleAdicionais(1) : null 
                            : this.toggleAdicionais(1)
                        }
                            name="sim"
                            className={this.state.adicionais === 1 ? 'option-selected' : 'option'}>
                            <span>Sim</span>
                        </div>
                    </div>
                </div>

                <hr/>

                {this.state.adicionais === 1 && (
                    <>
                    <div className="modos">
                            <div className="card"
                                onClick={() => this.setState({
                                    list: false
                                })}>
                                <FiGrid 
                                    color={this.state.list ? '#a49b9b' : '#000000'}
                                    size={16}/>
                                <h3 style={this.state.list ? {color: "#a49b9b"} : {color: "#000000"}}>Card</h3>
                            </div>
                            <div className="lista"
                                onClick={() => this.setState({
                                    list: true
                                })}>
                                <FiList 
                                    color={!this.state.list  ? '#a49b9b' : '#000000'}
                                    size={16}/>
                                <h3 style={!this.state.list  ? {color: "#a49b9b"} : {color: "#000000"}}>Lista</h3>
                            </div>
                        </div>
                    <div className="grupo-adicionais">
                        <h4>Grupo de adicionais</h4>
                        {
                            !!this.state.grupos.length ? (
                                this.state.list ? (
                                <DragDropContext onDragEnd={this.handleOnDrag}>
                                <Droppable droppableId="groups">
                                    {(provided) => (
                                        <>
                                        <table
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}>
                                            <thead>
                                                <tr>
                                                    <th className="th-drag"/>
                                                    <th className="th-nome">Nome</th>
                                                    <th className="th-nome">Itens</th>
                                                    <th className="th-switch"/>
                                                </tr>
                                            </thead>
                                            {this.state.grupos
                                            .sort((a, b) => Number(a.ordem) - Number(b.ordem))
                                            .map((item, index) => (
                                                <this.RenderList key={item.id} group={item} index={index} />
                                            ))}
                                            {provided.placeholder}
                                        </table>
                                        <div className="botao-div">
                                            <button 
                                                onClick={() => this.controllerModalAdicional(this.state.modalAdicional)}
                                                className="salvar-branco">
                                                adicionar novo grupo
                                            </button>
                                        </div>
                                        </>
                                    )}
                                </Droppable>
                                </DragDropContext>
                                ) : (
                                    <>
                                    <div className="itens">{
                                        <>
                                    {this.state.grupos
                                    .sort((a, b) => Number(a.ordem) - Number(b.ordem))
                                    .map(item => (
                                        <div className="item" key={item.id}>
                                            <div onClick={() => this.editarGrupo(item)}>
                                            <span className="title" 
                                        style = {{
                                             maxHeight: "1.4em", /* Duas linhas de altura aproximada */
                                             overflow: "hidden",
                                             textOverflow: "ellipsis",
                                             display: "-webkit-box",
                                             WebkitLineClamp: "2", /* Número de linhas desejado */
                                             WebkitBoxOrient: "vertical",
                                             width: "198px"
                                        }}>
                                            Nome
                                        </span>
                                                
                                                
                                                
                                                
                                                
                                                <span>{item.descricao}</span>
                                                <span className="title">
                                                    Itens
                                                </span>
                                              {item.adicionals &&  <span>{item.adicionals.length}</span> }
                                               
                                            </div>
                                            <button onClick={() => this.openModalApagar(item.id, item.descricao)}>
                                                <CgTrash color="#a09c9b" className="i-close" />  
                                            </button>
                                        </div>
                                    ))}
                                        {this.state.windowWidth > 426 && (
                                            <div
                                                onClick={() => this.controllerModalAdicional(this.state.modalAdicional)} 
                                                className="item-add">
                                                <span>Adicionar <p>novo grupo</p></span>
                                                <button>
                                                    <HiOutlinePlus color="#a32d33" className="i-close" />  
                                                </button>
                                            </div>
                                        )}
                                        </>
                                    }</div>
                                    {this.state.windowWidth <= 426 && (
                                        <div className="botao-div">
                                            <button 
                                                onClick={() => this.controllerModalAdicional(this.state.modalAdicional)}
                                                className="salvar-branco">
                                                adicionar novo grupo
                                            </button>
                                        </div>
                                    )}
                                    </>
                                )
                            ) : (
                                <h5 className="nao-cadastrou">Você não cadastrou nenhum grupo ainda.</h5>
                            )
                        }
                    </div>

                    {
                        !this.state.grupos.length ? (
                            <div className="botao-div">
                                <button
                                    className="salvar-branco" 
                                    onClick={() => this.controllerModalAdicional(this.state.modalAdicional)}>Novo adicional</button>
                            </div>
                        ) : null
                    }
                    </>
                )}
                    </div>
                ) : this.state.activeTab === 3 ? (
                    <>
                    {JSON.stringify(this.state.retorno) !== '{}' && this.state.retorno.imagem !== undefined ?
                    <>
                    <div className="header">
                        <img alt="" className="emoji" src={Smiley} />
                        <h1>Produto cadastrado</h1>
                        <h5>Muito bom! Agora que você já cadastrou todas 
                        as informações do seu produto vamos ativar ele.</h5>
                    </div>

                    <div className="imagem">
                        <h4>Foto do produto</h4>

                        <div className="foto">
                                <div 
                                    className="preview">
                                        <div className="imagem">
                                            <img src={this.state.retorno.imagem != null ? `https://appedidos-share-private.s3.amazonaws.com/${this.state.retorno.imagem}` : 'https://appedidos-share-private.s3.amazonaws.com/produto-sem-foto-listagem.jpg'} alt="" className="prev" />
                                        </div>
                                </div>
                        </div>
                    </div>

                    <div className="informacoes">
                        <h4>Informações básicas</h4>

                        <div className="div-input-disabled">
                                <input
                                    value={this.state.retorno.nome}
                                    onChange={
                                        (e) => this.state.superUser ? 
                            this.state.permission === 2 ? this.handleInputs(e) : null 
                            : this.handleInputs(e)
                                    }
                                    name="nome"
                                    type="text"
                                    // placeholder="Digite o seu usuário"
                                    disabled
                                    required 
                                    />
                                <label htmlFor="" className="label-name">
                                    <span className="content-name">Nome do seu produto</span>
                                </label>
                        </div>

                        <div
                            className="div-input-disabled">
                                <input
                                    value={this.state.retorno.categoria}
                                    // onFocus={() => {
                                    //     this.setState({
                                    //         categoriaClass: 'div-input-focado'
                                    //     })
                                    // }}
                                    // onBlur={() => {
                                    //     this.setState({
                                    //         categoriaClass: 'div-input'
                                    //     })
                                    // }}
                                    // readOnly
                                    name="nome"
                                    type="text"
                                    // placeholder="Digite o seu usuário"
                                    disabled
                                    required 
                                    />
                                <label htmlFor="" className="label-name">
                                    <span className="content-name">Categoria</span>
                                </label>
                                <button
                                    className="icon"
                                    >
                                    <FiChevronDown color="#1c0506" className="i" />
                                </button>
                        </div>

                    </div>

                    {/* <div className="ingredientes">
                        <div className="title"> */}
                    <div className='informacoes'>
                        <h4>Ingredientes</h4>
                        {/* <span>
                            <span style={ !!this.state.retorno.ingredientes.length ? { fontWeight: 550 } : null}>
                            {this.state.retorno.ingredientes.length}
                            </span>/140</span> */}
                        {/* </div> */}


                        <div className="div-input-disabled-box">
                                <textarea
                                    // maxLength={140}
                                    value={this.state.retorno.ingredientes}
                                    onChange={
                                        (e) => this.state.superUser ? 
                            this.state.permission === 2 ? this.handleInputs(e) : null 
                            : this.handleInputs(e)
                                    }
                                    name="ingredientes"
                                    type="text"
                                    // placeholder="Digite o seu usuário"
                                    disabled
                                    required 
                                    />
                                <label htmlFor="" className="label-name">
                                    <span className="content-name">Escreva sobre o seu produto</span>
                                </label>
                        </div>
                    </div>

                    <div className="preco">
                        <h4>Preço do produto</h4>

                        <div className="div-input-disabled">
                         
                            <input
                                value={`R$ ${(this.state.retorno.preco).replace('.', ',')}`}
                                name="preco"
                                type="text"
                                // placeholder="Digite o seu usuário"
                                disabled
                                required 
                                />
                                <label htmlFor="" className="label-name">
                                    <span className="content-name">Preço</span>
                                </label>
                        </div>
                    </div>

                    <hr/>
                    <div className="grupo-adicionais">
                        <h4 style={{padding: "1rem"}}>Grupo de adicionais</h4>
                        {
                            !!this.state.grupos.length ? (
                                <div className="itens" style={{paddingBottom: '1rem'}}>{
                                    <>
                                {this.state.grupos
                                .sort((a, b) => Number(a.ordem) - Number(b.ordem))
                                .map(item => (
                                    <div className="item-disabled" key={item.id}>
                                        
                                        <span className="title" 
                                        style = {{
                                             maxHeight: "1.4em", /* Duas linhas de altura aproximada */
                                             overflow: "hidden",
                                             textOverflow: "ellipsis",
                                             display: "-webkit-box",
                                             WebkitLineClamp: "2", /* Número de linhas desejado */
                                             WebkitBoxOrient: "vertical",
                                             width: "198px"
                                        }}>

                                            Nome
                                        </span>
                                        <span>{item.descricao}</span>
                                        <span className="title">
                                            Itens
                                        </span>
                                        <span>{item.adicionals.length}</span>
                                        {/* <button>
                                            <CgTrash color="#a09c9b" className="i-close" />  
                                        </button> */}
                                    </div>
                                ))}
                                    </>
                                }</div>
                            ) : (
                                <h5 style={{maxWidth: 290}}>Você não cadastrou nenhum grupo ainda.</h5>
                            )
                        }
                    </div>
                    <hr/>
                    <div className="situacao">
                        <h4>Situação do produto</h4>

                        <label className="switch">
                            <Switch
                                onChange={
                                    () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleSituacao() : null 
                                    : this.handleSituacao()
                                }
                                defaultChecked={this.state.situacao}
                                checked={this.state.situacao}
                            />
                            <h4>{this.state.situacao ? 'Ativado' : 'Desativado'}</h4>
                        </label>
                    </div>
                    <hr/>

                    <div className="editar">
                        <h4>Editar produto</h4>

                        <h5>Para editar o seu produto clique no botão abaixo</h5>
                        <div className="button-div">
                            <button 
                                onClick={() => this.salvarAlteracoes()}
                                className="salvar">Salvar alterações</button>
                        </div>
                    </div>
                    </>
                    : (
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '30%',}}>
                            <Spinner
                            className='spinner'
                            color="#c42027" size={20} speed={1} animating={true} />
                        </div>
                    )}
                    </>
                ) : (
                    <div style={{position: "relative"}}>
                    {this.state.windowWidth <= 426 && (
                            <div className="close">
                                <button 
                                    onClick={() => this.props.closeModal()}>
                                    <IoMdClose color="#fff" className="i-close" />
                                </button>
                            </div>
                    )}
                    <div className="header">
                        <img alt="" className="emoji" src={Carrinho} />
                        <h1>{this.props.edicao ? 'Editar produto' : 'Adicionar novo produto'}</h1>
                        <h5>Vamos começar pelas informações básicas.</h5>
                    </div>

                <div className="imagem">
                    <h4>Foto do produto</h4>

                    <div className="foto">
                        {!!this.state.uploaded.length ? (
                            <div 
                                className="preview"
                                onClick={() => this.handleDelFoto()}>
                                    <img src={Lixeira} alt="" className="lixeira"/>
                                    <div className="imagem">
                                        <img src={this.state.uploaded[0].preview} alt="" className="prev" />
                                    </div>
                                    <div style={{position: 'absolute', width: 28, height: 28, right: 3, bottom: 3}}>
                                        {!this.state.uploaded[0].uploaded && !this.state.uploaded[0].error && (
                                            <CircularProgressbar
                                            styles={{
                                                root: { width: 24 },
                                                path: { stroke: '#333333' }
                                            }}
                                            strokeWidth={10}
                                            value={this.state.uploaded[0].progress}
                                            />
                                        )}
                                        { this.state.imagem != null && this.state.uploaded[0].uploaded && !this.state.uploaded[0].error &&  <MdCheckCircle size={28} color="#4e9721" /> }
                                        { this.state.uploaded[0].error && !this.state.uploaded[0].uploaded &&  <MdError size={28} color="#c32027" /> }
                                    </div>
                            </div>
                        ) : (
                            <Dropzone accept="image/jpeg, image/png, image/pjpeg" multiple={false} onDropAccepted={
                                (file) => this.state.superUser ? 
                                this.state.permission === 2 ? this.handleUpload(file) : null 
                                : this.handleUpload(file)
                            }>
                                {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                    <DropContainer
                                        {...getRootProps()}
                                        haveImage={!!this.state.uploaded.length}
                                        isDragActive={isDragActive}
                                        isDragReject={isDragReject}
                                    >
                                        <input {...getInputProps()}/>
                                        <img src={ImageIcon} alt="" className="icon-image"/>
                                        {this.renderDragMessage(isDragActive, isDragReject, this.state.uploaded, 0)}
                                        {/* {!!this.state.uploaded.length && (
                                            <div style={{width: 28, height: 28, marginTop: 3}}>
                                                {!this.state.uploaded[0].uploaded && !this.state.uploaded[0].error && !isDragActive && (
                                                    <CircularProgressbar
                                                    styles={{
                                                        root: { width: 24 },
                                                        path: { stroke: '#333333' }
                                                    }}
                                                    strokeWidth={10}
                                                    value={this.state.uploaded[0].progress}
                                                    />
                                                )}
                                                { this.state.uploaded[0].uploaded && !this.state.uploaded[0].error && !isDragActive && <MdCheckCircle size={28} color="#4e9721" /> }
                                                { this.state.uploaded[0].error && !this.state.uploaded[0].uploaded && !isDragActive && <MdError size={28} color="#c32027" /> }
                                            </div>
                                        )} */}
                                    </DropContainer>
                                )}
                            </Dropzone>
                        )}
                    </div>
                </div>

                <div className="informacoes">
                    <h4>Informações básicas</h4>

                    <div className={this.state.nomeClass}>
                            <input
                                value={this.state.nome}
                                onFocus={() => {
                                    this.setState({
                                        nomeClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        nomeClass: 'div-input'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                        this.state.permission === 2 ? this.handleInputs(e) : null 
                        : this.handleInputs(e)
                                }
                                name="nome"
                                type="text"
                                // placeholder="Digite o seu usuário"
                                required 
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Nome do seu produto</span>
                            </label>
                    </div>
                    {this.state.nomeClass === 'div-input-error' && 
                    <div className="div-invalido">
                        <span
                        className='texto-invalido'
                        >Campo obrigatório</span>
                    </div>}

                    <div
                        onClick={() => this.controllerModal(this.state.isOpen)} 
                        className={this.state.categoriaClass}>
                            <input
                                value={this.state.categoria}
                                // onFocus={() => {
                                //     this.setState({
                                //         categoriaClass: 'div-input-focado'
                                //     })
                                // }}
                                // onBlur={() => {
                                //     this.setState({
                                //         categoriaClass: 'div-input'
                                //     })
                                // }}
                                // readOnly
                                name="nome"
                                type="text"
                                // placeholder="Digite o seu usuário"
                                required 
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Categoria</span>
                            </label>
                            <button
                                className="icon"
                                onClick={() => {this.controllerModal(this.state.isOpen)}}
                                >
                                <FiChevronDown color="#1c0506" className="i" />
                            </button>
                    </div>
                    {this.state.categoriaClass === 'div-input-error' && 
                    <div className="div-invalido">
                        <span
                        className='texto-invalido'
                        >Campo obrigatório</span>
                    </div>}

                </div>

                <div className="tamanho">
                    <h4>Tamanho do item</h4>

                    <div className="tamanhos">
                        <div 
                            onClick={() => this.handleTamanho(1)}
                            className={this.state.tamanho === 1 ? 'option-selected' : 'option'}>
                            <div>
                                <img src={Individual} alt=""/>
                            </div>
                            <span>
                                Individual
                            </span>
                        </div>
                        <div
                            onClick={() => this.handleTamanho(2)} 
                            className={this.state.tamanho === 2 ? 'option-selected' : 'option'}>
                            <div>
                                <img src={Dois} alt=""/>
                            </div>
                            <span>
                                2 pessoas
                            </span>
                        </div>
                        <div 
                            onClick={() => this.handleTamanho(3)}
                            className={this.state.tamanho === 3 ? 'option-selected' : 'option'}>
                            <div>
                                <img src={Tres} alt=""/>
                            </div>
                            <span>
                                3 pessoas
                            </span>
                        </div>
                        <div 
                            onClick={() => this.handleTamanho(4)}
                            className={this.state.tamanho === 4 ? 'option-selected' : 'option'}>
                            <div>
                                <img src={Quatro} alt=""/>
                            </div>
                            <span>
                                4 pessoas ou mais
                            </span>
                        </div>
                        <div
                            onClick={() => this.handleTamanho(null)} 
                            className={this.state.tamanho === null ? 'option-selected' : 'option'}>
                            <div>
                                <img src={Nao} alt=""/>
                            </div>
                            <span>
                                Não se aplica
                            </span>
                        </div>
                    </div>
                    {this.state.showSizeError && 
                    <div className="div-invalido">
                        <span
                        className='texto-invalido'
                        >Escolha obrigatoriamente uma opção</span>
                    </div>}
                    
                </div>



                <div className="ingredientes">
                    <div className="title">
                    <h4>Ingredientes</h4>
                    {/* <span>
                        <span style={ !!this.state.ingredientes.length ? { fontWeight: 550 } : null}>
                        {this.state.ingredientes.length}
                        </span>/140</span> */}
                    </div>

                    <div className={this.state.ingredientesClass}>
                            <textarea
                                // maxLength={140}
                                value={this.state.ingredientes}
                                onFocus={() => {
                                    this.setState({
                                        ingredientesClass: 'div-input-focado-box'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        ingredientesClass: 'div-input-box'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                }
                                name="ingredientes"
                                type="text"
                                required
                                // placeholder="Digite o seu usuário"
                                />
                            
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Escreva sobre o seu produto</span>
                            </label>
                    </div>
                </div>

                <div className="preco">
                    <h4>Preço do produto</h4>
                    {this.state.valorMinimo ?
                        <>
                            <div className='yellow-box-product'>
                                <text>
                                    O preço "a partir de" é a soma do preço do produto mais o preço dos adicionais que o cliente é obrigado a escolher. 
                                    Para alterar o preço base do produto, <span onClick={() => this.openInputPreco()}>clique aqui</span>.
                                </text>
                            </div>

                            <div className="div-input-disabled">
                                <input
                                    value={`R$ ${(this.state.valorMinimo).replace('.', ',')}`}
                                    name="preco"
                                    type="text"
                                    // placeholder="Digite o seu usuário"
                                    disabled
                                    required 
                                />
                                <label htmlFor="" className="label-name">
                                    <span className="content-name">A partir de</span>
                                </label>
                            
                            </div>
                            {this.state.inputPreco &&
                                <div id="preco-atual" className={this.state.precoClass}>
                                    <CurrencyInput
                                        inputType="text"
                                        maxLength="9"
                                        name="preco"
                                        prefix="R$ "
                                        onFocus={() => {
                                            this.setState({
                                                precoClass: 'div-input-focado'
                                            })
                                        }}
                                        onBlur={() => {
                                            this.setState({
                                                precoClass: 'div-input'
                                            })
                                        }}
                                        required
                                        decimalSeparator=","
                                        value={this.state.preco}
                                        onChangeEvent={
                                            (e) => this.state.superUser ? 
                                            this.state.permission === 2 ? this.handleInputs(e) : null 
                                            : this.handleInputs(e)
                                        }
                                    />
                                    <label htmlFor="" className="label-name">
                                        <span className="content-name">Preço</span>
                                    </label>
                                </div>
                            }
                        </>
                        :

                        <div className={this.state.precoClass}>
                            <CurrencyInput
                                inputType="text"
                                maxLength="9"
                                name="preco"
                                prefix="R$ "
                                onFocus={() => {
                                    this.setState({
                                        precoClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        precoClass: 'div-input'
                                    })
                                }}
                                required
                                decimalSeparator=","
                                value={this.state.preco}
                                onChangeEvent={
                                    (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                }
                            />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Preço</span>
                            </label>
                        </div>
                    }
                </div>
                    </div>
                )}
                {this.state.activeTab !== 3 && (
                    <div className="bottom-bar">
                        <BorderLinearProgress 
                                variant="determinate"
                                value={this.state.activeTab === 1 ? this.state.progress1 : this.state.progress2}
                                />
                        <div className="buttons">
                            <button className="back" onClick={() => this.changeTab('back') }>
                                <IoArrowBack color="#c0b7b8" className="icon" />
                                <span>
                                    Passo anterior
                                </span>
                            </button>

                            <button 
                                onClick={() => this.changeTab('next')}
                                className="next">
                                <span>
                                    {this.props.edicao && this.state.activeTab === 2 ? 'Salvar alterações' : 'Próximo passo'}
                                </span>
                            </button>
                        </div>
                    </div>
                )}
            </Container>
        )
    }
}

const StyledMenu = withStyles({
    paper: {
        position: 'absolute',
        width: 205,
        borderRadius: 8,
        top: 76,
        margin: 0,
        padding: 0
    }
  })(props => (
    <Menu
        TransitionComponent={Fade}  
        elevation={24}
        getContentAnchorEl={null}
        anchorOrigin={{
        vertical: "bottom", horizontal: "right"
      }}
      transformOrigin={{
        vertical: "top", horizontal: "right"
      }}
      {...props}
    />
  ));
  const StyledMenuItem = withStyles(theme => ({
    root: {
        fontFamily: "Montserrat",
        fontSize: 16,
        color: "#7a6d6d",
        paddingLeft: 16,
        paddingTop: 16,
        paddingBottom: 16,
        margin: 0,
        "&:hover": {
            fontWeight: 500,
            color: "#3f2829",
            backgroundColor: "#faf8f8"
        }
    }
  }))(MenuItem);

const entrada = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '322px',
        height: '100%',
        maxHeight: '256px'
      }
  };

const mobile = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -42%)',
        width: '100%',
        maxWidth: '360px',
        height: '85%',
      }
  };

const BorderLinearProgress = withStyles((theme) => ({
    colorPrimary: {
        backgroundColor: '#fff',
      },
    barColorPrimary: {
        backgroundColor: '#52dc75',
      }
}))(LinearProgress);

const adicionalStyle = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '775px',
        height: '100%',
        maxHeight: '800px'
      }
  };

  const apagarStyle = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '714px',
        height: '100%',
        maxHeight: '432px'
      }
  };